<template lang="pug">
v-navigation-drawer(
  :class="['limits overflow-hidden', $vuetify.breakpoint.mobile ? 'limits-full pa-4' : 'pa-8']"
  :value="getShowLimitsSidebar"
  absolute
  temporary
  right
  @input="setLimitsStatus")
  .limits_header
    span(class="limits_header--text") {{ $t('label.limits') }}
    v-btn(id="limits_header_close" icon @click="setLimitsStatus(false)")
      v-icon(size="12") $close
  v-divider
  .limits_body.mt-8
    p.limits_body--description.mb-5 {{ isVerified ? $t('misc.limits.verified.description') : $t('misc.limits.description') }}
    p.limits_body--description {{ $t('misc.limits.procedures') }}

    AppWarningComponent.mt-5(:warning-info="limitMessage")
    .limits_body--actions.mt-10
      v-btn.rounded-lg(id="limits_table_btn" depressed x-large :href="`https://mpay-docs.s3.us-east-1.amazonaws.com/limits_${userData?.language?.toLowerCase()}.pdf`" target="_blank" :color="isVerified ? 'primary' : '#EDEDED'") {{ $t('action.limits.table') }}
      v-btn.rounded-lg(v-if="!isVerified" id="limits_increase" depressed x-large color="primary" @click="toggleSimaModal") {{ $t('action.limits.increase') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppWarningComponent from '@/components/AppWarningComponent';

export default {
  name: 'AppLimits',
  components: {
    AppWarningComponent,
  },
  computed: {
    ...mapGetters('Ui', ['getShowLimitsSidebar']),
    ...mapGetters('user', {
      userData: 'getUserData',
    }),
    ...mapGetters('Limits', {
      limitMessage: 'getLimitMessage',
    }),
    isVerified() {
      return this.userData?.verificationStatus > 0;
    },
  },
  methods: {
    ...mapActions('Ui', ['setLimitsStatus']),
    toggleSimaModal() {
      this.$store.dispatch('user/setSimaModalStatus', true);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/components/appLimits.scss";
</style>
